var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedRisk)?_c('div',{staticClass:"users-bar white--text nobr text-ellipsis",class:_vm.selectedRisk.color,attrs:{"title":_vm.riskTitle}},[_vm._v("\n  Risque "+_vm._s(_vm.selectedRisk.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }